import React from 'react';

export default function Testimonial({
  icon,
  text,
  avatarName,
  avatarDesignation,
  style2,
}) {
  return (
    <div className={`cs_testimonial cs_style_1 ${style2 ? '' : 'text-center'}`}>
      <div className="cs_testimonial_icon">
        <img src={icon} alt="Icon" />
      </div>
      <blockquote
        className={`cs_testimonial_text font_futura ${style2 ? 'cs_white_color cs_fs_21' : 'cs_primary_color cs_fs_29'
          } cs_medium`} style={{ lineHeight: "30px", fontWeight: "400" }}

      >
        {text}
      </blockquote>
      <div className="cs_testimonial_info">
        <h3
          className={`cs_semibold ${style2 ? 'cs_white_color cs_fs_21' : 'cs_fs_29'
            }`}
        >
          {avatarName}
        </h3>
        <p className={style2 ? 'cs_gray_color_2' : ''}>{avatarDesignation}</p>
      </div>
    </div>
  );
}
